/*
 * zeroLabs: Fuß der Seite (sections/zl-fuss.liquid).
 * Land: Die Wahl im Fuß schickt das Formular sofort ab, ohne eigenen Knopf.
 * Gruppen: Am Handy (bis 768) klappt der Titel seine Gruppe auf und zu. Ab 769 sind alle offen, der Titel ist
 * dann kein Knopf (disabled), damit die Tastatur nicht an ihm hängen bleibt.
 * Labor der Startseite (templates/index.zl-fuss.json): Stehen mehrere Füße mit data-zlf-wahl auf der Seite,
 * zeigt ein Regler oben rechts je einen. Die Wahl bleibt beim Neuladen erhalten.
 */
(() => {
  const handy = window.matchMedia('(max-width: 768px)'); // token-ok: Grenze Handy wie in zl-fuss.css

  const knoepfe = () => {
    document.querySelectorAll('[data-zlf-knopf]').forEach((k) => {
      k.disabled = !handy.matches;
      if (k.dataset.zlfBereit) return;
      k.dataset.zlfBereit = 'ja';
      k.addEventListener('click', () => {
        const gruppe = k.closest('[data-zlf-gruppe]');
        const offen = !gruppe.classList.contains('ist-offen');
        gruppe.classList.toggle('ist-offen', offen);
        k.setAttribute('aria-expanded', String(offen));
      });
    });
  };

  const regler = () => {
    const fuesse = [...document.querySelectorAll('.zlf[data-zlf-wahl]')];
    if (fuesse.length < 2 || document.querySelector('.zlf-labor-wahl')) return;
    let gewaehlt = null;
    try { gewaehlt = localStorage.getItem('zl-fuss-wahl'); } catch (e) { /* ohne Speicher: erste Richtung */ }
    const zeige = (name) => {
      const ziel = fuesse.find((f) => f.dataset.zlfWahl === name) || fuesse[0];
      fuesse.forEach((f) => { f.hidden = f !== ziel; });
      leiste.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.name === ziel.dataset.zlfWahl)));
      try { localStorage.setItem('zl-fuss-wahl', ziel.dataset.zlfWahl); } catch (e) { /* egal */ }
    };
    const leiste = document.createElement('div');
    leiste.className = 'zlf-labor-wahl';
    leiste.setAttribute('role', 'group');
    leiste.setAttribute('aria-label', 'Fuß im Labor');
    fuesse.forEach((f) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.dataset.name = f.dataset.zlfWahl;
      b.textContent = f.dataset.zlfWahl;
      b.addEventListener('click', () => { zeige(b.dataset.name); f.scrollIntoView({ block: 'start' }); });
      leiste.append(b);
    });
    document.body.append(leiste);
    zeige(gewaehlt);
  };

  const start = () => {
    document.querySelectorAll('[data-zlf-land]').forEach((wahl) => {
      if (wahl.dataset.zlfBereit) return;
      wahl.dataset.zlfBereit = 'ja';
      wahl.addEventListener('change', () => wahl.form && wahl.form.submit());
    });
    knoepfe();
    regler();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  handy.addEventListener('change', knoepfe);
  document.addEventListener('shopify:section:load', start);
})();
